import ProfileSetting from '@/Component/Profile/ProfileSetting'
import NotificationPreferences from '@/Component/Profile/ProfileSetting/NotificationPreferences'

const NotificationPreferencesPage = () => {
    return (
        <ProfileSetting activeTab="notification-preferences">
            <NotificationPreferences />
        </ProfileSetting>
    )
}

export default NotificationPreferencesPage
